/**
 * Small "Saving… / Saved · just now / Save failed" pill.
 *
 * Consumes the return value of `useAutosave` and renders a compact status
 * indicator suitable for a page header. Hidden on mobile to keep the
 * header tight (the toast + composer flush covers mobile).
 */
import { useEffect, useState } from "react";

export default function AutosaveStatus({ status, savedAt }) {
  // Tick a re-render each 20s so the "Saved · Xs ago" text stays fresh.
  const [, setTick] = useState(0);
  useEffect(() => {
    if (status !== "saved") return;
    const t = setInterval(() => setTick((n) => n + 1), 20_000);
    return () => clearInterval(t);
  }, [status]);

  if (status === "idle") return null;
  const map = {
    saving: { text: "Saving…", tone: "text-slate-500", dot: "bg-amber-400 animate-pulse" },
    saved: { text: relTime(savedAt), tone: "text-emerald-700", dot: "bg-emerald-500" },
    error: { text: "Save failed", tone: "text-rose-700", dot: "bg-rose-500" },
  };
  const cfg = map[status] || map.saving;
  return (
    <div
      className={`hidden sm:inline-flex items-center gap-1.5 text-xs ${cfg.tone}`}
      data-testid="autosave-status"
    >
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.dot}`} />
      {cfg.text}
    </div>
  );
}

function relTime(d) {
  if (!d) return "Saved";
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 5) return "Saved · just now";
  if (s < 60) return `Saved · ${s}s ago`;
  const m = Math.floor(s / 60);
  return `Saved · ${m}m ago`;
}
